"use client";

var __jsx = React.createElement;
import APP_CONFIGURATION from "@lib/app.config";
import { cn } from "@lib/cn";
import { BREAKPOINTS } from "@lib/constants";
import EntityLogo from "@modules/shared/logos/entity-logo";
import PlatformLogo from "@modules/shared/logos/platform-logo";
import dynamic from "next/dynamic";
import React, { useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";

// Importar Lottie dinámicamente solo del lado del cliente
const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false // Esto evita que se intente renderizar en el servidor
  ,
  loadableGenerated: {
    webpack: () => [require.resolveWeak('lottie-react')]
  }
});
const MuscleLoattieAnimation = _ref => {
  let {
    height,
    color,
    lottieJson,
    text,
    addEntityLogo
  } = _ref;
  const animationRef = useRef(null);
  const {
    addEntityLogoInLoadingAnimation,
    usePlatformLogoInLoadingAnimation,
    heightEntityLogoInLoadingAnimation_md,
    heightEntityLogoInLoadingAnimation_sm,
    widthEntityLogoInLoadingAnimation_md,
    widthEntityLogoInLoadingAnimation_sm
  } = APP_CONFIGURATION.config;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  useEffect(() => {
    if (animationRef.current) {
      const pathElements = animationRef.current.querySelectorAll("path");
      pathElements.forEach(element => {
        element.setAttribute("fill", color);
      });
    }
  }, []);
  return __jsx("div", {
    ref: animationRef,
    className: "flex items-center justify-center"
  }, text && __jsx("span", {
    className: "text-3xl font-bold text-nowrap text-primary-main sm:text-3xl md:text-5xl"
  }, text), __jsx("div", {
    className: cn("flex items-center justify-center flex-col", addEntityLogoInLoadingAnimation && 'gap-8')
  }, addEntityLogoInLoadingAnimation && addEntityLogo && __jsx("div", {
    style: {
      maxWidth: isMobile ? widthEntityLogoInLoadingAnimation_sm : widthEntityLogoInLoadingAnimation_md
    }
  }, usePlatformLogoInLoadingAnimation ? __jsx("div", {
    className: "header-element min-w-[213px] w-fit"
  }, __jsx(PlatformLogo, {
    height: isMobile ? heightEntityLogoInLoadingAnimation_sm : heightEntityLogoInLoadingAnimation_md,
    width: isMobile ? widthEntityLogoInLoadingAnimation_sm : widthEntityLogoInLoadingAnimation_md,
    dataTestId: "header-entity-logo"
  })) : __jsx(EntityLogo, {
    height: isMobile ? heightEntityLogoInLoadingAnimation_sm : heightEntityLogoInLoadingAnimation_md
  })), __jsx(Lottie, {
    animationData: lottieJson,
    style: {
      height: height,
      width: "auto"
    }
  })));
};
export default MuscleLoattieAnimation;